// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TooltipPresentationProps } from "@conklin/MobiusOverrides/Tooltip";
import { ProductPriceStyles } from "@conklin/Overrides/Components/ProductPrice";
import { priceStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrice";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

export const priceStyle: TypographyPresentationProps = {
    variant: "h2",
    forwardAs: "p",
    css: css`
        &&& {
            margin: 0;
            white-space: nowrap;
            display: inline-block;
        }
    `,
};

priceStyles.productPrice = {
    wrapper: {
        css: css`
            width: auto;
            margin-bottom: 8px;
        `,
    },
    price: {
        unitOfMeasure: {
            unitOfMeasureText: {
                css: css`
                    white-space: nowrap;
                    font-size: 14px;
                    line-height: 17px;
                `,
            },
        },
        priceText: priceStyle,
        errorText: priceStyle,
        invalidPriceText: priceStyle,
    },
    invalidPriceText: priceStyle,
    quoteMessage: {
        text: priceStyle,
        tooltip: {
            extendedStyles: {
                triggerWrapper: {
                    css: css`
                        margin: 0 8px 8px;
                    `,
                },
            },
        } as TooltipPresentationProps,
    },
} as ProductPriceStyles;
